import React from "react";
import { ReactComponent as EditSquare } from "../assets/svg/EditSquare.svg";
import { ReactComponent as Category } from "../assets/svg/Category.svg";
import { ReactComponent as Chart } from "../assets/svg/Chart.svg";
import { ReactComponent as Activity } from "../assets/svg/Activity.svg";

const SectionMyServices = ({ sectionNumber }) => {
	return (
		<section id="my-services">
			<div className="container">
				<div className="relative">
					<div className="absolute -z-10 grid h-full w-full grid-rows-1 lg:grid-cols-4 lg:divide-x lg:divide-light lg:border-x lg:border-light">
						<div />
						<div />
						<div />
						<div />
					</div>
					<div className="flex items-center justify-center gap-2 pt-12 lg:gap-6">
						<h1 className="section-title__number">{sectionNumber}</h1>
						<h3 className="section-title__text">My Services</h3>
					</div>
					<div className="grid grid-cols-1 gap-8 pt-6 pb-20 sm:grid-cols-2 lg:grid-cols-4 lg:gap-0">
						<div className="group cursor-pointer bg-extralight py-10 px-5 transition duration-300 hover:bg-main lg:w-5/6">
							<EditSquare className="stroke-main transition duration-300 group-hover:stroke-white" />
							<h4 className="mt-6 mb-2 font-montserrat font-bold tracking-tighter transition duration-300 group-hover:text-white">
								UI/UX Design
							</h4>
							<p className="font-montserrat text-sm font-medium leading-6 tracking-tighter text-grey transition duration-300 group-hover:text-white">
								Lorem ipsum dolor sit amet consectetur adipisicing elit. Quis
								repudiandae dolores quisquam, commodi molestiae consectetur.
							</p>
						</div>
						<div className="group cursor-pointer bg-extralight py-10 px-5 transition duration-300 hover:bg-main lg:w-5/6">
							<Category className="stroke-main transition duration-300 group-hover:stroke-white" />
							<h4 className="mt-6 mb-2 font-montserrat font-bold tracking-tighter transition duration-300 group-hover:text-white">
								Product Design
							</h4>
							<p className="font-montserrat text-sm font-medium leading-6 tracking-tighter text-grey transition duration-300 group-hover:text-white">
								Lorem ipsum dolor sit amet consectetur adipisicing elit. Quis
								repudiandae dolores quisquam, commodi molestiae consectetur.
							</p>
						</div>
						<div className="group cursor-pointer bg-extralight py-10 px-5 transition duration-300 hover:bg-main lg:w-5/6">
							<Chart className="stroke-main transition duration-300 group-hover:stroke-white" />
							<h4 className="mt-6 mb-2 font-montserrat font-bold tracking-tighter transition duration-300 group-hover:text-white">
								Brand Identity
							</h4>
							<p className="font-montserrat text-sm font-medium leading-6 tracking-tighter text-grey transition duration-300 group-hover:text-white">
								Lorem ipsum dolor sit amet consectetur adipisicing elit. Quis
								repudiandae dolores quisquam, commodi molestiae consectetur.
							</p>
						</div>
						<div className="group cursor-pointer bg-extralight py-10 px-5 transition duration-300 hover:bg-main lg:w-5/6">
							<Activity className="stroke-main transition duration-300 group-hover:stroke-white" />
							<h4 className="mt-6 mb-2 font-montserrat font-bold tracking-tighter transition duration-300 group-hover:text-white">
								Website Design
							</h4>
							<p className="font-montserrat text-sm font-medium leading-6 tracking-tighter text-grey transition duration-300 group-hover:text-white">
								Lorem ipsum dolor sit amet consectetur adipisicing elit. Quis
								repudiandae dolores quisquam, commodi molestiae consectetur.
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default SectionMyServices;
